module.exports = __webpack_public_path__ + "img/back-navigation-arrow.97ee6d75.svg";